export default __webpack_public_path__ + "static/media/smbc.642bf6f5.svg";